import axios from 'axios'

export default async function deleteAdSiteSection(id: number) {
  await axios.delete(`/api/v1/ad-site-section/by-section-id/${id}`)
}
